<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-sm-12" [innerHtml]="text">
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="command-panel" *NgFor="let item of handlers">
        <button type="button"  class="btn ms-2" [ngClass]="'btn-' + item.style"
        (click)="submit(item.value)">{{item.displayName}}</button>   
    </div>
</div>